var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"waterfallRef",staticClass:"waterfall-flow"},_vm._l((_vm.columns),function(column,index){return _c('div',{key:index,staticClass:"column"},_vm._l((column.columnArr),function(item){return _c('div',{key:'column-item-' + item.slotName,staticClass:"item",style:({width: _vm.columnWidth + 'rem'})},[_vm._t(item.slotName)],2)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }